module.exports = __webpack_public_path__ + "img/canned-food.ca4a6c55.webp";